
<script>
  import { __, getStoreById } from '~/data-utils';
  import { openingHours, lang } from 'apps/imd/stores';
  import A from '../../action';
  import Logo from 'components/Logo.svelte';
  import OpeningHoursRow from './OpeningHoursRow.svelte';
  import OpeningHoursFormatter from './formatter';
  import ScrollContainer from 'components/ScrollContainer.svelte';
  import Title, { H2, H3 } from 'components/Title.svelte';
  import UseResource from 'components/svg/UseResource.svelte';

  let formatter;

  $: if ($lang) {
    formatter = new OpeningHoursFormatter($lang, __);
  }

  
  let shoppingCenterOpeningHours = [];
  let exceptionalOpeningHours = [];
  let highlightedStores = [];

  $: if ($openingHours) {
    ({
      shoppingCenterOpeningHours,
      exceptionalOpeningHours
    } = $openingHours);
    highlightedStores = $openingHours.highlightedStores
      .filter(store => store.unformattedOpeningHours && store.unformattedOpeningHours.length)
      .map(store => {
        const {
          logoURL: logo,
          exceptionalOpeningHours: exceptions = []
        } = getStoreById(store.id);

        return { logo, hasExceptions: exceptions.length, ...store };
      }
      );
  }

</script>


<ScrollContainer height="calc(100% - 136px)">
{#if formatter}
  <div class="opening-hours">

    <div class="opening-hours__column">

      <section class="column__section">
        <Title tag={H2}>{__('common.shoppingCenter')}</Title>
        <ul class="opening-hours__list">
          {#each shoppingCenterOpeningHours as data, i (data)}
          <li data-testid="hours-{i}">
            <OpeningHoursRow {data} {formatter} />
          </li>
          {/each}
        </ul>
      </section>

      {#if exceptionalOpeningHours.length}
      <section class="column__section">
        <Title tag={H2}>{__('common.openingHoursExceptions')}</Title>
        <ul class="opening-hours__list">
          {#each exceptionalOpeningHours as data, i (data.date)}
          <li data-testid="except-{i}">
            <OpeningHoursRow {data} {formatter} />
          </li>
          {/each}
        </ul>
      </section>
      {/if}

    </div>

    <div class="opening-hours__column">
      {#each highlightedStores as store, i (store.id)}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div on:click={() => A.showStoreInfo(store.id)} class="store-item" data-testid="high-{i}">
          <div class="card">
            <div class="store-item__logo">
              <Logo {store} />
            </div>
            <div class="store-item__details">
              <ul class="opening-hours__list">
                <li data-testid="high-{i}__title">
                  <Title tag={H3}>{store.name}</Title>
                </li>
                {#each store.unformattedOpeningHours as data, j (data)}
                <li data-testid="high-{i}__{j}">
                  <OpeningHoursRow {data} {formatter} />
                </li>
                {/each}
              </ul>
              {#if store.hasExceptions}
                <div class='label'>{__('common.seeExceptions')}</div>
              {/if}
            </div>
          </div>
          <div class='arrow'>
            <UseResource name='ic_arrow-right--flat' style="--max: 100%" />
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}
</ScrollContainer>

<style>
  .opening-hours {
    display: flex;
    flex-direction: row;
    padding: 0 40px;
    overflow: auto;
  }

  .opening-hours__column {
    width: 50%;
    padding: 0 24px;
  }

  .opening-hours__column::after {
    content: ' ';
    display: block;
    height: 64px;
  }

  .column__section {
    margin: 32px 0 48px;
  }

  .opening-hours__list {
    margin-bottom: 16px;
    list-style: none;
  }

  .store-item {
    position: relative;
    margin: 16px 0;
  }

  .card {
    display: flex;
    padding-bottom: 16px;
    padding-right: 24px;
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .2);
    background: var(--content-bg--secondary);
  }

  .store-item__details {
    margin: 16px 0 0 24px;
  }

  .label {
    width: 100%;
    height: 40px;
    margin-top: 16px;
    background: var(--highlight);
    border-radius: 500px;
    color: var(--textOnHighlight);
    line-height: 35px;
    text-align: center;
  }

  .arrow {
    position: absolute;
    width: 16px;
    right: -40px;
    top: 50%;
    transform: translateY(-50%);
    filter: var(--content-icon--filter);
    opacity: .25;
  }
</style>
